module.exports = __webpack_public_path__ + "static/media/part-return-slide-7.aa3cd1a8.jpg";